import axios from './_contaAxios'

export const obtenerAsSelect = () => axios.get('/proyectos', { params: { tipoConsulta: 'select' } })
